import i18n from '../../locales/index'
import restful from '../vuex'
import axios from 'axios'
import { Message, Spin } from 'view-design'

const state = {
  ...restful.states('mall_order')
}

const getters = {
  ...restful.getters('mall_order'),
  aggregate_test: (state) =>
    i18n.t('store_modules_mall_order_1330', [state.meta.first,state.meta.second,state.meta.third])
}

const actions = {
  ...restful.actions('mall_orders'),
  async deliver_order ({ commit }, id) {
    Spin.show()
    const res = await axios.post(`mall_orders/${id}/deliver`)
    commit('setRecord', res.data)
    Spin.hide()
    Message.success(i18n.t('store_modules_mall_order_1331'))
  }
}

const mutations = {
  ...restful.mutations('mall_order')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
